import { useState } from "react";
import { Link } from "react-router-dom";
import { api, fmtErr } from "@/lib/api";
import { MailCheck } from "lucide-react";
import { toast } from "sonner";

const INPUT = "w-full mt-1 px-3 py-2.5 rounded-lg border border-slate-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-100 outline-none text-sm";

export const AuthShell = ({ children }) => (
  <div className="min-h-screen bg-white text-slate-900 flex items-center justify-center p-6 font-[Inter,system-ui,sans-serif]">
    <div className="w-full max-w-md">
      <Link to="/" className="flex items-center justify-center mb-8"><img src="/recruitsift-logo.png" alt="RecruitSift" className="h-10 w-auto" /></Link>
      {children}
    </div>
  </div>
);

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try { await api.post("/auth/forgot-password", { email }); setSent(true); }
    catch (err) { toast.error(fmtErr(err.response?.data?.detail)); }
    finally { setLoading(false); }
  };

  return (
    <AuthShell>
      <div className="bg-white border border-slate-200 rounded-2xl p-8 shadow-sm">
        {sent ? (
          <div className="text-center" data-testid="forgot-sent">
            <MailCheck className="w-10 h-10 text-emerald-600 mx-auto mb-3" />
            <h1 className="text-xl font-bold mb-2">Check your email</h1>
            <p className="text-sm text-slate-500">If an account exists for <span className="font-medium text-slate-700">{email}</span>, we've sent a link to reset your password. It works once and expires in 24 hours.</p>
            <p className="text-xs text-slate-400 mt-3">Don't see it? Check your spam folder.</p>
          </div>
        ) : (
          <form onSubmit={submit} data-testid="forgot-form">
            <h1 className="text-2xl font-bold mb-1">Forgot password?</h1>
            <p className="text-sm text-slate-500 mb-6">Enter your work email and we'll send you a reset link.</p>
            <label className="text-xs font-semibold uppercase tracking-wider text-slate-500">Email</label>
            <input data-testid="forgot-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className={INPUT} />
            <button data-testid="forgot-submit" disabled={loading} className="mt-6 w-full py-2.5 rounded-lg bg-slate-900 hover:bg-slate-800 text-white font-semibold text-sm disabled:opacity-60">
              {loading ? "Sending…" : "Send reset link"}
            </button>
          </form>
        )}
        <div className="mt-5 text-center text-sm text-slate-500">
          <Link to="/login" data-testid="back-to-login" className="text-blue-600 hover:text-blue-700 font-medium">Back to sign in</Link>
        </div>
      </div>
    </AuthShell>
  );
}
